// extracted by mini-css-extract-plugin
export default {"title":"SimpleModal_title__AIU3D","iconSuccess":"SimpleModal_iconSuccess__gVMe6","iconError":"SimpleModal_iconError__17bDs"};